import { ErrorMessage } from "@hookform/error-message";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Modal, ModalBody } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row,
} from "../../components/Component";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import Table from "../../components/react-table/Table";
import { DELETE, GET, POST, PUT } from "../../helper/api";
import { toast } from "react-toastify";

const DEFAULT_SEAPORT = { name: "", address: "" };

const PNSeaportManager = () => {
  const { errors, register, handleSubmit, reset } = useForm({ defaultValues: DEFAULT_SEAPORT });
  const [seaports, setSeaports] = useState([]);
  const [modal, setModal] = useState(false);
  const [editId, setEditId] = useState(null);

  const fetchSeaports = () => {
    GET("/pn-seaport", {}, true).then(({ data }) => setSeaports(data));
  };

  useEffect(() => { fetchSeaports(); }, []);

  const openCreate = () => {
    setEditId(null);
    reset(DEFAULT_SEAPORT);
    setModal(true);
  };

  const openEdit = (row) => {
    setEditId(row.id);
    reset({ name: row.name, address: row.address || "" });
    setModal(true);
  };

  const onSubmit = (data) => {
    const request = editId
      ? PUT(`/pn-seaport/${editId}`, data, {}, true)
      : POST("/pn-seaport", data, {}, true);
    request
      .then(() => {
        toast.success(editId ? "Cập nhật thành công" : "Thêm thành công");
        setModal(false);
        fetchSeaports();
      })
      .catch((err) => toast.error(err.response?.data?.error || "Có lỗi xảy ra"));
  };

  const onDelete = (id) => {
    if (!window.confirm("Bạn có chắc muốn xóa cảng biển này?")) return;
    DELETE(`/pn-seaport/${id}`, {}, true)
      .then(() => { toast.success("Xóa thành công"); fetchSeaports(); })
      .catch((err) => toast.error(err.response?.data?.error || "Có lỗi xảy ra"));
  };

  const columns = [
    { Header: "Tên cảng", accessor: "name" },
    { Header: "Địa chỉ", accessor: "address" },
    {
      Header: "",
      accessor: "id",
      Cell: ({ row }) => (
        <div className="d-flex gap-2">
          <Button size="sm" color="primary" onClick={() => openEdit(row.original)}>
            <Icon name="edit" /><span>Sửa</span>
          </Button>
          <Button size="sm" color="danger" onClick={() => onDelete(row.original.id)}>
            <Icon name="trash" /><span>Xoá</span>
          </Button>
        </div>
      ),
    },
  ];

  return (
    <>
      <Head title="Quản lý cảng biển" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Quản lý cảng biển</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <Button color="primary" onClick={openCreate}>
                <Icon name="plus" /> Thêm cảng biển
              </Button>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <Table notShowPagi columns={columns} data={seaports} />
            </div>
          </div>
        </Block>
      </Content>

      <Modal isOpen={modal} toggle={() => setModal(false)}>
        <ModalBody>
          <BlockTitle tag="h5" className="mb-3">
            {editId ? "Cập nhật cảng biển" : "Thêm cảng biển"}
          </BlockTitle>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Row className="g-2">
              <Col size={12}>
                <div className="form-group">
                  <label className="form-label">Tên cảng <span className="text-danger">*</span></label>
                  <input
                    className="form-control"
                    name="name"
                    ref={register({ required: "Vui lòng nhập tên cảng" })}
                  />
                  <ErrorMessage errors={errors} name="name" render={({ message }) => <span className="invalid">{message}</span>} />
                </div>
              </Col>
              <Col size={12}>
                <div className="form-group">
                  <label className="form-label">Địa chỉ</label>
                  <input className="form-control" name="address" ref={register()} />
                </div>
              </Col>
              <Col size={12} className="d-flex justify-content-end gap-2 mt-2">
                <Button type="button" color="light" onClick={() => setModal(false)}>Hủy</Button>
                <Button type="submit" color="primary">Lưu</Button>
              </Col>
            </Row>

          </form>
        </ModalBody>
      </Modal>
    </>
  );
};

export default PNSeaportManager;
